import connectSite from './connect-site';
import copyPage from './copy-page';
import createPage from './create-page';
import createPageFromTemplate from './create-page-from-template';
import deletePage from './delete-page';
import setActivePage from './set-active-page';
import setPagesInNavigation from './set-pages-in-navigation';
import setHomePage from './set-home-page';
import setHtmlCheckpoint from './set-html-checkpoint';
import setPageHTML from './set-page-html';
import setPageUsedBlocks from './set-page-used-block';
import setSession from './set-session';
import setSettings from './set-settings';
import setSiteId from './set-site-id';
import setSiteName from './set-site-name';
import setSiteProperties from './set-site-properties';
import setSiteProperty from './set-site-property';
import updateSettings from './update-settings';
import updatePageSettings from './update-page-settings';
import setOwnerId from './set-owner-id';
import setMultilingual from './set-multilingual';
import setPages from './set-pages';
import setUpdatedAt from './set-updated-at';
import setLastAppliedMigrationId from './set-last-applied-migration-id';
import setCleanUrlsEnabled from './set-clean-urls-enabled';
import exportSite from './export-site';
import setRedirects from './set-redirects';
import updateRedirects from './update-redirects';
import initSettingsForFirstLoading from './init-settings-for-first-loading';
import setIntegrations from './set-integrations';
import updateIntegrations from './update-integrations';
import reloadSiteMeta from './reload-site-meta';
import addFolder from './add-folder';
import deleteFolder from './delete-folder';
import renameFolder from './rename-folder';
import moveToFolder from './move-to-folder';
import addPageBinding from './add-page-binding';
import updatePageBinding from './update-page-binding';
import removePageBinding from './remove-page-binding';

export default {
  connectSite,
  copyPage,
  createPage,
  createPageFromTemplate,
  deletePage,
  setActivePage,
  setPagesInNavigation,
  setHomePage,
  setHtmlCheckpoint,
  setOwnerId,
  setPageHTML,
  setPageUsedBlocks,
  setSession,
  setSettings,
  setSiteId,
  setSiteName,
  setSiteProperties,
  setSiteProperty,
  updateSettings,
  updatePageSettings,
  setMultilingual,
  setPages,
  setUpdatedAt,
  setLastAppliedMigrationId,
  setCleanUrlsEnabled,
  exportSite,
  setRedirects,
  updateRedirects,
  initSettingsForFirstLoading,
  setIntegrations,
  updateIntegrations,
  reloadSiteMeta,
  addFolder,
  deleteFolder,
  renameFolder,
  moveToFolder,
  addPageBinding,
  updatePageBinding,
  removePageBinding,
};
